import config from "../utils/config";
import { isTokenExpired, clearAuthStorage } from "../utils/tokenUtils";

// Refresh interval method
let refreshIntervalMethod = undefined;

// Action types
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const REFRESH_TOKEN = "REFRESH_TOKEN";

// Create Redux action creators that return an action
export const logIn = (jwt) => {
  //setRefreshInterval(jwt, refreshCallback);
  setTokenInLocalStorage(jwt);
  window.scrollTo(0, 0);
  return {
    type: LOG_IN,
    payload: jwt,
  };
};

export const logOut = () => {
  clearRefreshInterval();
  clearAuthStorage();
  return {
    type: LOG_OUT,
  };
};

export const refreshTokenAction = (newToken) => {
  return {
    type: REFRESH_TOKEN,
    payload: newToken,
  };
};

export const restoreAuth = () => {
  const jwt = localStorage.getItem(config.jwt_key_name);
  const refreshToken = localStorage.getItem("refreshToken");

  if (jwt && !isTokenExpired(jwt)) {
    return {
      type: LOG_IN,
      payload: jwt,
    };
  }

  // Access expired but refresh still present — keep session; interceptor will refresh
  if (refreshToken && jwt) {
    return {
      type: LOG_IN,
      payload: jwt,
    };
  }

  clearAuthStorage();
  return { type: "NO_ACTION" };
};

// const setRefreshInterval = async (jwt, refreshCallback) => {
//   if (refreshIntervalMethod) return; // ako metoda nije undefined znaci da je vec setovan interval

//   let durationMinutes = await decodeToken(jwt).then(
//     (tokenData) => tokenData.durationMinutes
//   );
//   durationMinutes /= 60;

//   // TODO: vrati sa 6 na 60
//   refreshIntervalMethod = setInterval(
//     () => refreshCallback(jwt),
//     durationMinutes * 60 * 1000
//   );
// };

const clearRefreshInterval = () => {
  clearInterval(refreshIntervalMethod);
  refreshIntervalMethod = undefined;
};

const setTokenInLocalStorage = (jwt) => {
  localStorage.setItem(config.jwt_key_name, jwt);
};
